export default __webpack_public_path__ + "static/white-ee78965fc1ace33409f37c1d16c7b0c5.jpg";